import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import gitaPhoto from '../assets/Gita-cropped.jpg';
import kitchenPhoto from '../assets/kitchen.JPG';
import familyRoomPhoto from '../assets/familyroom.JPG';
import ReviewForm from '../components/ReviewForm';
import { supabase } from '../supabaseClient';

function Home() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showBuyersDropdown, setShowBuyersDropdown] = useState(false);
  const [userReviews, setUserReviews] = useState([]);
  const navigate = useNavigate();
  
  const images = [
    {
      id: 2,
      src: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Luxury modern home exterior',
      title: 'Gita Kashani',
      description: 'Focused on Los Altos, Menlo Park, Atherton, Mountain View, Sunnyvale, Cupertino and Redwood City'
    },
    {
      id: 3,
      src: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Beautiful home with landscaping',
      title: 'Gita Kashani',
      description: 'One stop shop to prepare, market and sell your property'
    },
    {
      id: 4,
      src: familyRoomPhoto,
      alt: 'Spacious family room',
      title: 'Gita Kashani',
      description: 'Connecting buyers and sellers in Silicon Valley\'s premier neighborhoods'
    },
    {
      id: 5,
      src: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Elegant living room interior',
      title: 'Gita Kashani',
      description: 'Your trusted partner for seamless real estate transactions'
    },
    {
      id: 6,
      src: kitchenPhoto,
      alt: 'Modern kitchen',
      title: 'Gita Kashani',
      description: 'Maximizing your property value through strategic market positioning'
    },
    {
      id: 7,
      src: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Spacious luxury kitchen',
      title: 'Gita Kashani',
      description: 'Personalized service with deep local market knowledge'
    },
    {
      id: 8,
      src: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Beautiful home entrance',
      title: 'Gita Kashani',
      description: 'Making your real estate dreams a reality with expert guidance'
    },
    {
      id: 9,
      src: 'https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Modern home with beautiful architecture',
      title: 'Gita Kashani',
      description: 'Trusted advisor for all your real estate investment decisions'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % images.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentImageIndex(index);
  };

  const nextSlide = () => {
    setCurrentImageIndex((prevIndex) => 
      (prevIndex + 1) % images.length
    );
  };

  const prevSlide = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleConnectClick = () => {
    navigate('/contact');
  };

  const handleBuyersClick = () => {
    console.log('For Buyers clicked!');
    setShowBuyersDropdown(!showBuyersDropdown);
  };

  const handleDropdownOptionClick = (option) => {
    setShowBuyersDropdown(false);
    if (option === 'buying-services') {
      // Scroll to services section
      const servicesSection = document.querySelector('.services-section');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (option === 'mortgage-calculator' || option === 'search') {
      navigate('/videos'); // Navigate to Tools page
    }
  };

  // Load user reviews from Supabase
  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = async () => {
    try {
      const { data, error } = await supabase
        .from('reviews')
        .select('*')
        .eq('approved', true)
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      // Transform to match testimonial format
      const formattedReviews = (data || []).map(review => ({
        id: `review-${review.id}`,
        text: review.text,
        name: review.name
      }));
      
      setUserReviews(formattedReviews);
    } catch (error) {
      console.error('Error loading reviews:', error);
    }
  };

  // All testimonials now come from the database
  const allTestimonials = userReviews;

  // Scroll testimonials left/right
  const scrollTestimonials = (direction) => {
    const container = document.querySelector('.testimonials-grid');
    if (container) {
      const scrollAmount = 412; // Card width (380) + gap (32)
      container.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  };


  return (
    <div className="home">
      <section className="image-carousel">
        <div className="carousel-container">
          {images.map((image, index) => (
            <div 
              key={image.id}
              className={`carousel-slide ${index === currentImageIndex ? 'active' : ''} ${image.id === 8 ? 'gradient-overlay' : ''}`}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="carousel-image"
              />
              <div className="carousel-gita-badge">
                <img src={gitaPhoto} alt="Gita Kashani" />
                <span className="gita-name">Gita Kashani</span>
              </div>
              <div className="carousel-overlay">
                <div className="carousel-content">
                  <p>{image.description}</p>
                  <button className="cta-button" onClick={handleConnectClick}>Let's Connect</button>
                </div>
              </div>
            </div>
          ))}
          
          <button className="carousel-nav prev" onClick={prevSlide}>
            &#8249;
          </button>
          <button className="carousel-nav next" onClick={nextSlide}>
            &#8250;
          </button>
          
          <div className="carousel-dots">
            {images.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="agent-section">
        <div className="container">
          <div className="agent-content">
            <div className="agent-image">
              <img 
                src={gitaPhoto} 
                alt="Gita Kashani - Professional Realtor"
              />
            </div>
            <div className="agent-info">
              <h2>Gita Kashani</h2>
              <h3>REALTOR / MORTGAGE BROKER</h3>
              <p>
                For more than 30 years, I've been dedicated to helping families, individuals, and investors realize their real estate ambitions. Whether you're searching for your dream home, selling a cherished property, or securing the ideal mortgage, my extensive local expertise and keen understanding of market trends put you at a distinct advantage. With access to over 120 lenders, I offer a full spectrum of financing solutions to match your unique needs.
              </p>
              <p>
                Real estate is about more than buying and selling houses—it's about discovering a place that truly fits your lifestyle and future plans. My commitment is to personally guide you through every step of the process, equipping you with the right tools, resources, and advice to make your journey rewarding, seamless, and free of stress.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <h2>What My Clients Say</h2>
          <div className="testimonials-container">
            <button className="testimonial-nav prev" onClick={() => scrollTestimonials('prev')}>
              ‹
            </button>
            <div className="testimonials-grid">
              {allTestimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-card">
                  <div className="quote-mark">"</div>
                  <p className="testimonial-text">
                    "{testimonial.text}"
                  </p>
                  <div className="client-info">
                    <h4>{testimonial.name}</h4>
                    {testimonial.title && <span>{testimonial.title}</span>}
                  </div>
                </div>
              ))}
            </div>
            <button className="testimonial-nav next" onClick={() => scrollTestimonials('next')}>
              ›
            </button>
          </div>
          <ReviewForm onReviewSubmitted={loadReviews} />
        </div>
      </section>


      <section className="agency-info-section">
        <div className="container">
          <h2>Agency Info</h2>
          <div className="agency-info-content">
            <div className="agency-details">
              <div className="info-item">
                <h3>Real Estate Source, Inc.</h3>
                <p><a href="https://realestatesourceinc.com/" target="_blank" rel="noopener noreferrer">https://realestatesourceinc.com/</a></p>
              </div>
              <div className="info-item">
                <h4>Contact Information</h4>
                <p>
                  Phone: 
                  <span className="phone-desktop">(650) 283-3537</span>
                  <a href="tel:650-283-3537" className="phone-mobile">Call (650) 283-3537</a>
                </p>
                <p>Email: gita@realestatesourceinc.com</p>
              </div>
              <div className="info-item">
                <h4>Service Areas</h4>
                <p>Los Altos, Menlo Park, Atherton, Mountain View, Cupertino, Sunnyvale, Redwood City</p>
              </div>
              <div className="info-item">
                <h4>Business Hours</h4>
                <p>9:00 AM to 6:00 PM weekdays and weekends</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;